import { twMerge } from "tailwind-merge";
import { Holiday } from "hooks/console/useConsoleHoliday";
import { DAY_STATE_LABEL, DAY_STATE_STYLE, getDayState, WEEKDAY_KO } from "./holidayUtils";

type HolidayMonthListProps = {
    holidays: Holiday[];
    onSelect: (dateStr: string) => void;
};

// 이번 달 휴무일 요약 목록 — 캘린더 아래, 셀에서 잘린 긴 명칭까지 한눈에 확인
export default function HolidayMonthList({ holidays, onSelect }: HolidayMonthListProps) {
    return (
        <div className="mt-[24px]">
            <h4 className="text-[15px] font-[600] text-[#222222] mb-[8px]">이번 달 휴무일</h4>
            {holidays.length === 0 ? (
                <p className="text-[14px] text-[#999999] py-[12px]">등록된 휴무일이 없습니다. (주말은 자동 휴무)</p>
            ) : (
                <ul className="divide-y divide-[#EEEEEE] border-y border-[#EEEEEE]">
                    {holidays.map(h => {
                        const state = getDayState(h.holiday_date, h);
                        const dow = WEEKDAY_KO[new Date(`${h.holiday_date}T00:00:00Z`).getUTCDay()];
                        return (
                            <li key={h.holiday_no}>
                                <button
                                    type="button"
                                    onClick={() => onSelect(h.holiday_date)}
                                    className="w-full flex items-center gap-[8px] py-[12px] text-left text-[14px]"
                                >
                                    <span className={twMerge("w-[6px] h-[6px] rounded-full shrink-0", DAY_STATE_STYLE[state].dot)} />
                                    <span className="text-[#222222] whitespace-nowrap">
                                        {h.holiday_date.slice(5)}({dow})
                                    </span>
                                    <span className={twMerge("whitespace-nowrap", DAY_STATE_STYLE[state].text)}>
                                        {DAY_STATE_LABEL[state]}
                                        {h.kind === "early" && ` ${h.end_time}`}
                                    </span>
                                    <span className="text-[#666666] truncate">· {h.name}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
